<template>
<div class="chapter">
<div class="inner_page">
<p class="prect" id="ack1"><a id="pX"></a><a id="pXI"></a><i>Translator’s Acknowledgments</i></p>
<p class="ftxt">Sincere thanks to Edward M. Strauss, translator of <i>Poilu: The World War I Notebooks of Corporal Louis Barthas, Barrelmaker, 1914–1918</i> (Yale University Press, 2014), and to an anonymous reader for their patience and helpful comments on the manuscript. It has been a pleasure to work with the extremely efficient and accommodating Erica Hanson and Dan Heaton of Yale University Press. Jesse Waidler of the Massachusetts Army National Guard kindly discussed military terminology with me. My colleague Marie McDonough provided in-valuable assistance in translating <a href="#/ch6.htm#ch6">Chapters 6</a>, <a href="#/ch7.htm#ch7">7</a>, and <a href="#/ch8.htm#ch8">8</a>. And finally, I thank Bruno Cabanes for his unstinting support and collegiality.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// translators_acknowledgments.vue?1f3936f0